import React from 'react';
import { FaLock } from 'react-icons/fa';

interface LockIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const LockIcon: React.FC<LockIconProps> = ({ 
  size = 16, 
  color = 'currentColor',
  className = ''
}) => {
  return (
    <FaLock
      size={size}
      color={color}
      className={className}
      title="Tournée verrouillée"
    />
  );
};

export default LockIcon;